import * as React from 'react';
import cx from 'classnames';
type Props = React.SVGProps<SVGSVGElement> & {
  size?: number;
};
export function Svg9000ArrowRight(ps: Props) {
  const style = Object.assign(
    {},
    ps.style,
    ps.size
      ? {
          width: ps.size,
          height: ps.size,
        }
      : {},
  );
  const props: Props = Object.assign({}, ps, {
    style,
    className: cx('svg-icon', ps.className),
  });
  return (
    <svg
      aria-hidden="true"
      width={12}
      height={12}
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        className="9000-arrow-right_svg__st0"
        d="M13.93 20.638L22.568 12 13.93 3.362"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
      />
      <path
        className="9000-arrow-right_svg__st1"
        d="M1.432 12h21.136"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
      />
    </svg>
  );
}
